import React from "react";
import {
  BulkActionProps,
  Button,
  useNotify,
  useRefresh,
  useUnselectAll,
  useUpdateMany,
} from "react-admin";
import { VisibilityOff } from "@material-ui/icons";
import { Visibility } from "@material-ui/icons";
import { AdminResource } from "reactAdmin/resource/resource";

interface Props extends BulkActionProps {
  enable: boolean;
}

const UserDisableEnableButton: React.FC<Props> = ({
  selectedIds,
  enable = true,
}) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [updateMany, { loading }] = useUpdateMany(
    AdminResource.users,
    selectedIds || [],
    { enable },
    {
      onSuccess: () => {
        refresh();
        notify(enable ? "Users enabled" : "Users disabled");
        unselectAll(AdminResource.users);
      },
      onFailure: (error) => notify("Error: users not updated", "warning"),
    }
  );

  return (
    <Button
      label={enable ? "Enable" : "Disable"}
      disabled={loading}
      onClick={updateMany}
    >
      {enable ? <Visibility /> : <VisibilityOff />}
    </Button>
  );
};

export default UserDisableEnableButton;
